var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 44,
    viewBox: "0 0 56 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7635 13.6863C55.7635 16.3506 55.1892 18.6661 54.0486 20.6207C52.9039 22.5835 51.2901 24.0961 49.1991 25.1666C47.112 26.2372 44.6286 26.7765 41.7731 26.7765H34.1732V14.9394L44.0907 15.0691V11.971L31.0831 11.8412V34.9397L19.2768 43.6787V11.8372H0L8.51802 0H41.769C44.6246 0 47.1039 0.535276 49.195 1.60991C51.282 2.67643 52.8999 4.18903 54.0445 6.13553C55.1851 8.07798 55.7595 10.9856 55.7595 13.6782L55.7635 13.6863Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6063 39.5099C49.4942 39.1044 51.4195 37.3525 52.3457 34.6477C53.2841 34.8545 53.915 35.1627 54.5581 35.8481C55.3266 36.6632 55.6299 37.4701 55.7027 38.5934C55.7149 38.7637 55.6502 38.8246 55.4965 38.8448C52.9241 39.2139 51.1323 40.7629 50.1414 43.1231C50.0335 43.3772 49.8488 43.4637 49.5872 43.3826C47.8197 42.8311 46.7722 41.5334 46.6104 39.6802C46.6063 39.6315 46.6104 39.5788 46.6104 39.5058L46.6063 39.5099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6064 38.5974C46.7642 36.2292 48.9685 34.23 51.4883 34.4206C51.1648 35.3735 50.6956 36.2211 49.9999 36.9388C49.0777 37.8959 47.925 38.4028 46.6024 38.5974H46.6064Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7638 39.6841C55.5373 41.8861 53.4422 43.8488 50.9183 43.6704C51.2904 42.6849 51.8162 41.8171 52.5807 41.1075C53.4705 40.2843 54.5423 39.8463 55.7638 39.6841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpLogo);
export default __webpack_public_path__ + "static/media/tp-logo.c89d94498d29483d76c617ab4a49ef4d.svg";
export { ForwardRef as ReactComponent };